import { RouteObject } from 'react-router';

import { BotSettingPage } from './page/BotSettingPage';
import { MainContainer } from './containers/MainContainer';
import { WelcomeMessageContainer } from './containers/WelcomeMessageContainer';
import { SHOP_CURRENT_ROUTE } from '../../utils/constants';

const routes: RouteObject[] = [
    {
        path: `${SHOP_CURRENT_ROUTE}/bot-settings`,
        element: <BotSettingPage />,
        children: [
            {
                path: 'main',
                element: <MainContainer />,
            },
            {
                path: 'welcome-message',
                element: <WelcomeMessageContainer />,
            },
        ],
    },
];
export default routes;
